import React, { useEffect, useState } from 'react';
import ErrorBoundary from '../../components/ErrorBoundary';
import ExpandedPostModal from '../../post/modalView/ExpandedPostModal';
import ExtensionErrorBoundary from './ExtensionErrorBoundary';
import sendMessageToSlabFrame, {
  listenerFrameMessage,
} from './sendMessageToSlabFrame';
import { Corner } from './shared/types';

const ExtensionPost = () => {
  const [postParams, setPostParams] = useState<{
    id: string;
    isPersisted: boolean;
  } | null>(null);

  useEffect(() => {
    const cleanup = listenerFrameMessage((message) => {
      if (message['slab.type'] === 'post.load') {
        setPostParams(message['slab.data']);
      } else if (message['slab.type'] === 'post.unload') {
        setPostParams(null);
      }
    });

    sendMessageToSlabFrame({ 'slab.type': 'ready' });

    return cleanup;
  }, []);

  return (
    postParams && (
      <ErrorBoundary
        name="ExtensionPost"
        renderFallback={() => (
          <ExtensionErrorBoundary
            errorMessage={
              <>
                Unable to load post content.
                <br />
                Please refresh the page or try again later.
              </>
            }
          />
        )}
      >
        <ExpandedPostModal
          initialId={postParams.id}
          key={postParams.id}
          frameless
          close={() => {
            sendMessageToSlabFrame({
              'slab.type': 'close',
            });
          }}
          onDraggingStart={
            postParams.isPersisted
              ? (position) => {
                  sendMessageToSlabFrame({
                    'slab.type': 'dragging.start',
                    'slab.data': position,
                  });
                }
              : undefined
          }
          onDraggingMove={(position) => {
            sendMessageToSlabFrame({
              'slab.type': 'dragging.move',
              'slab.data': position,
            });
          }}
          onDraggingEnd={() => {
            sendMessageToSlabFrame({
              'slab.type': 'dragging.end',
            });
          }}
          onResizeStart={
            postParams.isPersisted
              ? (position, corner) => {
                  if (corner === Corner.BottomRight) {
                    sendMessageToSlabFrame({
                      'slab.type': 'resize.start',
                      'slab.data': position,
                    });
                  }
                  sendMessageToSlabFrame({
                    'slab.type': 'resize.corner.start',
                    'slab.data': { position, corner },
                  });
                }
              : undefined
          }
          onResizeMove={(position, corner) => {
            if (corner === Corner.BottomRight) {
              sendMessageToSlabFrame({
                'slab.type': 'resize.move',
                'slab.data': position,
              });
            }
            sendMessageToSlabFrame({
              'slab.type': 'resize.corner.move',
              'slab.data': { position },
            });
          }}
          onResizeEnd={() => {
            sendMessageToSlabFrame({
              'slab.type': 'resize.end',
            });
          }}
        />
      </ErrorBoundary>
    )
  );
};

export default ExtensionPost;
